import { DestinationTypes } from '../../../shared/constants';

const Icon = ({ type }: { type: string }) => {
  const { FNF, FNR } = DestinationTypes;
  switch (type) {
    case FNR:
      return (
        <svg width="62" height="28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="62" height="28" rx="3" fill="#FFCB0B" />
          <path
            d="M9.625 20.875h11.25M6.09 10.25h1.348L9 12.125h2.5l-.976-2.927a.624.624 0 0 1 .593-.823h1.32l3.438 3.75h4.375a2.5 2.5 0 0 1 2.5 2.5V16.5H8.985a2.5 2.5 0 0 1-2.394-1.782l-1.1-3.663a.625.625 0 0 1 .6-.805z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path stroke="currentColor" strokeDasharray="2 2" d="M24 13.5h14" />
          <path
            d="M41.438 14h13.124M41.438 9.625h13.124M45.5 20.25l-1.875 2.5M50.5 20.25l1.875 2.5M52.688 6.5h-9.376c-1.035 0-1.874.84-1.874 1.875v10c0 1.035.839 1.875 1.874 1.875h9.376c1.035 0 1.874-.84 1.874-1.875v-10c0-1.036-.839-1.875-1.874-1.875zM48 9.625V14"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M44.563 18.063a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25zM51.438 18.063a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25z"
            fill="currentColor"
          />
        </svg>
      );
    case FNF:
      return (
        <svg width="62" height="28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="62" height="28" rx="3" fill="#FFCB0B" />
          <path
            d="M9.625 20.875h11.25M6.09 10.25h1.348L9 12.125h2.5l-.976-2.927a.624.624 0 0 1 .593-.823h1.32l3.438 3.75h4.375a2.5 2.5 0 0 1 2.5 2.5V16.5H8.985a2.5 2.5 0 0 1-2.394-1.782l-1.1-3.663a.625.625 0 0 1 .6-.805z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path stroke="currentColor" strokeDasharray="2 2" d="M24 13.5h14" />
          <path
            d="m55.27 12.643-1.02-.34V8.374A1.25 1.25 0 0 0 53 7.125h-4.375v-1.25a.625.625 0 1 0-1.25 0v1.25H43a1.25 1.25 0 0 0-1.25 1.25v3.927l-1.02.341a1.25 1.25 0 0 0-.855 1.187v2.678c0 .058.008.115.024.17 1.228 4.305 6.728 5.787 7.818 6.04.186.043.38.043.566 0 1.09-.253 6.59-1.735 7.818-6.04a.604.604 0 0 0 .024-.17V13.83a1.25 1.25 0 0 0-.855-1.187zM43 8.375h10v3.51l-4.802-1.603a.626.626 0 0 0-.396 0L43 11.885v-3.51zm11.875 8.042c-.452 1.485-1.605 2.748-3.434 3.76A14.2 14.2 0 0 1 48 21.5a14.2 14.2 0 0 1-3.438-1.323c-1.83-1.012-2.985-2.276-3.437-3.76V13.83l6.25-2.086v5.382a.624.624 0 1 0 1.25 0v-5.382l6.25 2.087v2.587z"
            fill="currentColor"
          />
        </svg>
      );
    default:
      return null;
  }
};

export default Icon;
